import { Http } from '@gamiphy/http';
import { Faq } from '@gamiphy/bl/faq';
import { LoyaltyPageSettings } from '@gamiphy/bl/loyaltyPage';

class LoyaltyPageApi {
  public static async getFaqs(): Promise<Faq[] | []> {
    const response = await Http.get<GetFaqResponse>({
      url: '/v2/faqs',
    });
    return response.data.faqs;
  }

  public static async bulkUpdate(faqs: Omit<Faq, 'id'>[]): Promise<Faq[]> {
    const response = await Http.post<GetFaqResponse>({
      url: '/v2/faqs/bulk',
      payload: {
        faqs,
      },
    });
    return response.data.faqs;
  }

  public static async getLoyaltyPageSettings(): Promise<LoyaltyPageSettings> {
    const response = await Http.get<LoyaltyPageSettingsResponse>({
      url: '/v2/loyalty-page',
    });
    return response.data.loyaltyPage;
  }

  public static async createLoyaltyPageSettings(data: LoyaltyPageSettings): Promise<LoyaltyPageSettings> {
    const response = await Http.post<LoyaltyPageSettingsResponse>({
      url: '/v2/loyalty-page',
      payload: data,
    });
    return response.data.loyaltyPage;
  }

  public static async updateLoyaltyPageSettings(data: LoyaltyPageSettings): Promise<LoyaltyPageSettings> {
    const response = await Http.patch<LoyaltyPageSettingsResponse>({
      url: '/v2/loyalty-page',
      payload: data,
    });
    return response.data.loyaltyPage;
  }
}

export default LoyaltyPageApi;

export type GetFaqResponse = {
  faqs: Faq[] | []
}

export type LoyaltyPageSettingsResponse = {
  loyaltyPage: LoyaltyPageSettings;
}
